module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-09-162cfbeb9a3d9a61ab1926b9f6372fdf.jpg";